import noUiSlider from 'nouislider';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      $( document ).on( 'click', '.js-back', ( e ) => {
        if ( window.history.length > 1 && document.referrer.indexOf( window.location.host ) !== -1 ) {
          e.preventDefault();
          window.history.back();
        }
      } );

      document.addEventListener( 'click', ( e ) => {
        if ( !e.target.closest( '#search-wrapper' ) || e.target.closest( '.ais-SearchBox-reset' ) ) {
          $( '#hits' ).addClass( 'hidden' );
        }
      } );

      document.addEventListener( 'focus', ( e ) => {
        if ( e.target.matches( '#search-wrapper input[type="search"]' ) ) {
          $( '#hits' ).removeClass( 'hidden' );
        }
      }, true );

      if ( document.referrer.indexOf( window.location.host ) !== -1 ) {
        $( '.js-back' ).attr( 'href', document.referrer );
      }

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      $( '.js-slide-toggle' ).on( 'toggleAfter', ( event ) => {
        const $target = $( `${event.target?.dataset.toggleTarget}.js-slide-toggle-target` );
        $target?.slideToggle();
      } );

      $( '.js-search-toggle' ).on( 'toggleAfter', ( event ) => {
        if ( window.easyToggleState.isActive( event.target ) ) {
          setTimeout( () => {
            $( '#search-wrapper input' ).focus();
          }, 0 );
        }
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      $( '#mpf-back' ).on( 'click', function( e ) {
        e.preventDefault();
        $( '.gform_page_footer .gform_previous_button' ).trigger( 'click' );
      } );
    },
    finalize: function() {
      if ( typeof gform !== 'undefined' ) {
        gform.addFilter( 'gform_spinner_target_elem', function( $targetElem, formId ) {
          return $targetElem.closest( '.data-content' );
        } );
      }

      const smsShare = document.querySelector( '.heateor_sss_button_sms' );
      if ( smsShare ) {
        smsShare.href = smsShare.href.replace( 'sms:?', `sms:${siteInfo.phone}?` );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
